import { transliterate } from 'transliteration'
export const toCanonical = (raw: string): string => {
	return transliterate(raw) // 1. кириллица → latin
		.normalize('NFKD') // 2. отчистка юникода
		.replace(/[\u0300-\u036F]/g, '') //    (снимаем диакритику)
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9._~-]+/g, '-') // 3. всё «лишнее» → «-»
		.replace(/^-+|-+$/g, '') // 4. нет висящих дефисов
		.replace(/-{2,}/g, '-') // 5. одиночный дефис
}
